import { render, staticRenderFns } from "./AlbumDetails.vue?vue&type=template&id=644043d0"
import script from "./AlbumDetails.vue?vue&type=script&lang=js"
export * from "./AlbumDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports